<template>
  <div>
    <a-spin :spinning="loading">
      <a-row :gutter="16">
        <a-col :span="24">
          <h5 class="mb-1"></h5>
          <a-form layout="inline">
            <a-form-item :help="_trs('Delivery date')">
              <a-date-picker
                v-model="date"
                :placeholder="_trs('Select date')"
                valueFormat="YYYY-MM-DD"
                @change="getHoursForDate"
              />
            </a-form-item>
            <a-form-item>
              <a-select
                v-model="hour"
                @change="search"
                style="min-width: 80px;"
              >
                <a-select-option
                  v-for="timeStep in hours"
                  :key="timeStep.id"
                  :value="timeStep.id"
                >
                  {{ timeStep.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-button class="btn btn-success" @click="search">{{
                _trs('Get results')
              }}</a-button>
            </a-form-item>
          </a-form>

          <p class="font-weight-light mb-3"></p>
          <p
            class="text-center"
            style="font-size: 18px;"
            v-show="price != null"
          >
            <span class="mr-1">{{ _trs('Price') }}:</span>
            <span class="text-bold mr-3">{{ price }} €/MWh</span>
            <span class="mr-1">{{ _trs('Volume') }}:</span>
            <span class="text-bold">{{ volume }} MWh</span>
          </p>
          <div
            style="height: 450px;"
            class="mb-10"
            id="bid-ask-curve-chart"
          ></div>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>
<script>
import { XmlService } from '@/services/api'

import { Chart, registerInteraction } from '@antv/g2'
import { Modal } from 'ant-design-vue'
import moment from 'moment'
import { _trs } from '../../../../utilities'

export default {
  name: 'BidAskCurves',
  components: {},

  data: function () {
    return {
      loading: false,
      bidAskData: [],
      chart: null,
      hour: null,
      dateFormat: 'YYYY-MM-DD',
      date: moment().add(1, 'day'),
      hours: [],
      price: null,
      volume: null,
    }
  },
  methods: {
    _trs,
    isDateTooOld(date) {
      if (!date) return false
      const twoWeeksAgo = moment().subtract(14, 'days').startOf('day')
      return moment(date).isBefore(twoWeeksAgo)
    },
    showDateRestrictionModal() {
      Modal.warning({
        title: _trs('Data Not Available'),
        content: _trs('Data older than 2 weeks is available upon request according to the commercial terms. Contact dam@belen-spot.me for more info.'),
      })
    },
    async getHoursForDate() {
      if (this.isDateTooOld(this.date)) {
        this.loading = false
        this.showDateRestrictionModal()
        this.hours = []
        this.hour = null
        this.price = null
        this.volume = null
        this.bidAskData = []
        return
      }
      this.loading = true
      const response = await XmlService.getHoursForDate(
        moment(this.date).format('YYYY-MM-DD')
      )
      this.loading = false
      this.hours = response.data.hours
      if (this.hour == null && this.hours.length) {
        // set first avaialble
        this.hour = this.hours[0].id
        this.search()
      }
      // this.hour = '00-01'
      // this.getData()
    },
    search() {
      if (this.date == null || this.date == '') {
        Modal.warning({
          title: _trs('Date is not set'),
          content: _trs('Please choose the date to fetch the data'),
        })
        return false
      }
      if (this.isDateTooOld(this.date)) {
        this.loading = false
        this.showDateRestrictionModal()
        return false
      }
      this.getData()
    },
    async getData() {
      var filter = {
        day: moment(this.date).format('YYYY-MM-DD'),
        hour: this.hour,
      }
      this.loading = true
      const response = await XmlService.getBidAskCurves({ filter })
      this.loading = false
      this.bidAskData = response.data.data
      this.price = response.data.price
      this.volume = response.data.volume
      this.drawPatternChart()
    },
    drawPatternChart() {
      console.log('Drawing pattern chart')
      if (this.chart) {
        this.chart.destroy()
      }

      const data = this.bidAskData

      const chart = new Chart({
        container: 'bid-ask-curve-chart',
        autoFit: true,
        height: '100%',
        padding: 'auto',
      })

      chart.data(data)

      chart.tooltip({
        showTitle: false,
      })

      chart.axis('volume', {
        title: {},
      })

      chart.axis('price', {
        title: {},
      })

      chart.scale('price', {
        nice: true,
        tickInterval: 50,
        alias: _trs('Price [EUR/MWh]'),
      })

      chart.scale('volume', {
        nice: true,
        alias: _trs('Volume [MWh]'),
      })

      chart
        .line()
        .position('volume*price')
        .shape('hv')
        .color('direction')
        .style({
          opacity: 1,
          lineWidth: 2,
        })
        .tooltip(false)

      chart
        .point()
        .position('volume*price')
        .color('direction')
        .size(4)
        .shape('circle')
        .style({
          stroke: '#fff',
          lineWidth: 2,
        })
        .tooltip('direction*volume*price', (direction, volume, price) => {
          return {
            name: direction + ': ' + volume + 'MW',
            value: (price == null ? ' - ' : price) + ' 	&euro;/MWh',
          }
        })

      registerInteraction('drag-move', {
        start: [{ trigger: 'plot:mousedown', action: 'scale-translate:start' }],
        processing: [
          {
            trigger: 'plot:mousemove',
            action: 'scale-translate:translate',
            throttle: { wait: 100, leading: true, trailing: false },
          },
        ],
        end: [{ trigger: 'plot:mouseup', action: 'scale-translate:end' }],
      })
      chart.interaction('drag-move')

      chart.interaction('view-zoom')

      chart.legend({
        position: 'bottom',
        // marker: 'square',
      })

      chart.render()
      chart.getCanvas().on('mousewheel', (ev) => {
        ev.preventDefault()
      })

      this.chart = chart
    },
  },
  async mounted() {
    await this.getHoursForDate()
  },
}
</script>

<style scoped>
.mp-0 {
  margin: 0px;
  padding: 0px;
  line-height: 1em;
}

.mr-15 {
  margin-right: 15px;
}
.text-bold {
  font-weight: 600;
}
</style>
